// import Form from 'antd/lib/form/Form'
import React from 'react';
import { InfluencerOtpValidationFormComponent } from '../../components/AuthForms/InfluencerOtpValidationFormComponent';

export const InfluencerOtpValidationPage = () => {
  return (
    <div className="signup_wrapper">
      <div className="container-fluid vh-100 px-0">
        <div className="d-flex align-items-center">
          <div className="col-md-6 px-0">
            <div className="signup_wrapper_poster">
              <img src="/images/common/flynt-creator-posters.jpg"
                alt="Otp Poster" />
            </div>
          </div>
          <div className="col-md-6">
            <div>
              <div className="signup_wrapper_content">
                <h4>Verify your mobile number</h4>
                <p>Please verify your mobile number for secure future use.</p>
                {/* <OtpValidationFormComponent/> */}
                <InfluencerOtpValidationFormComponent/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
